/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const financialsStatementSlideDtoSchema = z.object({
  pageNumber: z.optional(z.int()),
  caption: z.optional(z.string()),
  alt: z.optional(z.string()),
});
